var _ellipse, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 12,
  cy: 17.5,
  rx: 7,
  ry: 3.5,
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 4,
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
export default SvgUser;